/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const MultiColumnFragment = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  MultiColumn: gql`
    fragment MultiColumnQuery on multiColumn_Entry {
      backgroundImage {
        url
        ... on images_Asset {
          altText
        }
      }
      columnList {
        ... on columnListBlock_Entry {
          columnContent {
            html
          }
          dropdown {
            dropdownLabel
            dropdownLink
            dropdownLinkNewTab
            dropdownLinkNofollow
          }
          dropdownAlignment
          dropdownButtonType
          dropdownTitle
        }
      }
      componentTitle
      addVerticalSeparators
      highlightedTextModal1: highlightedTextModal13 {
        ... on highlightedTextModal13Block_Entry {
          modalContent {
            html
          }
        }
      }
      highlightedTextModal2: highlightedTextModal23 {
        ... on highlightedTextModal23Block_Entry {
          modalContent {
            html
          }
        }
      }
      lineBreak_mainContent
      lineBreak_modals
      lineBreak_styles
      styles
      twoColumnDistribution
      typeHandle
    }
  `,
};
